import Tooltip from "bootstrap/js/dist/tooltip";

export function init_tooltips(root_el) {
  if (!root_el) {
    return [];
  }

  const triggers = root_el.querySelectorAll('[data-bs-toggle="tooltip"]');

  return Array.from(triggers).map((trigger) => new Tooltip(trigger));
}

export function dispose_tooltips(instances) {
  (instances || []).forEach((instance) => instance.dispose());
}
